import { Component, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-image',
	templateUrl: './image.component.html',
	styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit {
	@Input() path?: string = ''
	@Input() title?: string = ''
	@Input() load: boolean = false

	default?: {
		defaultImage: string
		errorImage: string
	}

	ngOnInit(): void {}
}
